export function berechneZielgroesse(breite: number, hoehe: number, maxKante = 1600) {
  const lang = Math.max(breite, hoehe);
  if (lang <= maxKante) return { breite, hoehe };
  const faktor = maxKante / lang;
  return { breite: Math.round(breite * faktor), hoehe: Math.round(hoehe * faktor) };
}

// Browser-Teil: Handyfotos sind 3–8 MB; ohne Verkleinerung dauert der Upload über
// Mobilfunk ewig und das PDF wird unbrauchbar groß.
export async function skaliereBild(datei: Blob, maxKante = 1600): Promise<Blob> {
  const bitmap = await createImageBitmap(datei);
  const { breite, hoehe } = berechneZielgroesse(bitmap.width, bitmap.height, maxKante);
  const canvas = document.createElement('canvas');
  canvas.width = breite;
  canvas.height = hoehe;
  const ctx = canvas.getContext('2d');
  if (!ctx) return datei;
  ctx.drawImage(bitmap, 0, 0, breite, hoehe);
  bitmap.close();
  return new Promise(resolve =>
    canvas.toBlob(b => resolve(b ?? datei), 'image/jpeg', 0.8),
  );
}
